// Webpack Imports
import * as bootstrap from 'bootstrap';

(function () {
	'use strict';

	// Focus input if Searchform is empty
	[].forEach.call(document.querySelectorAll('.search-form'), (el) => {
		el.addEventListener('submit', function (e) {
			var search = el.querySelector('input');
			if (search.value.length < 1) {
				e.preventDefault();
				search.focus();
			}
		});
	});

	// Initialize Popovers: https://getbootstrap.com/docs/5.0/components/popovers
	var popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'));
	var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
		return new bootstrap.Popover(popoverTriggerEl, {
			trigger: 'focus',
		});
	});
})();



document.addEventListener('DOMContentLoaded', function () {
	const menuButton = document.querySelector('.menu-button'); // Update the selector
	const navbar = document.querySelector('#navbar');

	menuButton.addEventListener('click', function () {
		menuButton.classList.toggle('active');
		navbar.classList.toggle('active');
	});
});


// Event listener to close the menu when clicking outside of it
document.addEventListener("click", function (event) {
	const menuButton = document.querySelector(".menu-button");
	const menu = document.querySelector("#navbar");

	if (!menuButton.contains(event.target) && !menu.contains(event.target)) {
		menu.classList.remove("active");
	}
});


document.addEventListener("DOMContentLoaded", function () {
	var header = document.getElementById("header");
	var main = document.getElementById("main");
	var stickyOffset = 200; // Set the desired offset for sticky behavior
	var sticky = header.offsetTop + stickyOffset;

	function updateSticky() {
		if (window.scrollY > sticky) {
			header.classList.add("sticky");
			main.classList.add("sticky-main");
		} else {
			header.classList.remove("sticky");
			main.classList.remove("sticky-main");
		}
	}

	window.addEventListener("scroll", updateSticky);

	// Call the function once to apply sticky styles on page load
	updateSticky();
});

document.addEventListener('DOMContentLoaded', function () {
	var expertiseTitles = document.querySelectorAll('.expertise_title');

	expertiseTitles.forEach(function (expertiseTitle) {
		var expertiseIcon = expertiseTitle.previousElementSibling;

		expertiseTitle.addEventListener('mouseover', function () {
			expertiseIcon.classList.add('expertise-hovered');
		});

		expertiseTitle.addEventListener('mouseout', function () {
			expertiseIcon.classList.remove('expertise-hovered');
		});
	});
});
